export default __webpack_public_path__ + "static/media/serchmovies.b8a35840.jpg";